export default __webpack_public_path__ + "static/media/tags-stack-selected.45aa129d.svg";